/* ============================================================================
   ROAM PDP — behaviour for the custom sections.
   Vanilla JS, no dependencies. Supports multiple instances on a page.
   Handles: option selection → variant matching, gallery, bundle/quantity
   tiers + price math, sticky bars, AJAX add-to-cart, accordions.
   ========================================================================== */
(function () {
  'use strict';

  // Several sections (main-product, accordions, FAQ) each drop a <script src>
  // for this file, and duplicate tags execute once per tag. Without this guard
  // boot() ran repeatedly and stacked a submit listener on the product form per
  // run, so one click fired several /cart/add.js requests.
  if (window.roamPdpInit) return;
  window.roamPdpInit = true;

  /* ---- money formatting (Shopify money_format aware) -------------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var fmt = format || '${{amount}}';
    var num = (cents / 100).toFixed(2);
    function thousands(n, dec, ts, ds) {
      n = (n + '').replace(/[^0-9.-]/g, '');
      var parts = parseFloat(n).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts || ',');
      return parts.join(ds || '.');
    }
    var placeholder = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = placeholder ? placeholder[1] : 'amount';
    switch (token) {
      case 'amount': value = thousands(num, 2, ',', '.'); break;
      case 'amount_no_decimals': value = thousands(num, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = thousands(num, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(num, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = thousands(num, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = thousands(num, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = thousands(num, 0, ' ', ','); break;
      default: value = thousands(num, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---- cart drawer helpers (page-level, not per-section) ---------------- */
  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Re-render / open the drawer via roam-cart.js, which owns the drawer's
  // markup contract. Falls back to no-ops if that script is not on the page.
  function renderCartDrawer() {
    if (window.roamCart) return window.roamCart.render();
    return Promise.resolve(false);
  }

  function openCartDrawer() {
    return window.roamCart ? window.roamCart.open() : false;
  }

  function updateCartCount(cart) {
    document.querySelectorAll('[data-roam-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('roam-cart-btn__count--empty', cart.item_count === 0);
    });
    // theme-native bubbles, if this theme's header is in use instead
    document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(function (el) {
      (el.querySelector('span') || el).textContent = cart.item_count;
    });
    document.querySelectorAll('.roam-cart-btn').forEach(function (btn) {
      btn.setAttribute('aria-label', 'Cart (' + cart.item_count + ' items)');
    });
  }

  /* ---- per-section controller ------------------------------------------- */
  function initSection(root) {
    // idempotent: a re-entrant boot must never double-bind the same form
    if (root.dataset.roamPdpBound) return;
    root.dataset.roamPdpBound = '1';

    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var cartAction = root.getAttribute('data-cart-action') || 'drawer';
    var urlSync = root.hasAttribute('data-roam-url-sync');
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-roam-variants]').textContent); } catch (e) { variants = []; }

    var form = root.querySelector('[data-roam-form]') || root.querySelector('#roam-product-form') || root.querySelector('form[action*="/cart/add"]');
    var idInput = root.querySelector('[data-roam-variant-id]');
    var qtyInput = root.querySelector('[data-roam-quantity]');
    var atc = root.querySelector('[data-roam-atc]');
    var atcLabel = root.querySelector('[data-roam-atc-label]');
    var atcPrice = root.querySelector('[data-roam-atc-price]');

    // current selection
    var selectedOptions = [];
    root.querySelectorAll('[data-roam-opt][aria-checked="true"]').forEach(function (btn) {
      selectedOptions[parseInt(btn.getAttribute('data-roam-opt'), 10) - 1] = btn.getAttribute('data-value');
    });
    var currentVariant = variants.filter(function (v) { return v.id == (idInput && idInput.value); })[0] || variants[0];
    var currentTier = root.querySelector('[data-roam-bundle][aria-checked="true"]');

    /* ---- variant matching ---- */
    function findVariant() {
      return variants.filter(function (v) {
        return selectedOptions.every(function (val, i) {
          return val == null || v.options[i] === val;
        });
      })[0];
    }

    function fmt(c) { return formatMoney(c, moneyFormat); }

    /* ---- price math for the selected variant + tier ---- */
    function tierData() {
      var q = currentTier ? parseInt(currentTier.getAttribute('data-qty'), 10) || 1 : (parseInt(qtyInput.value, 10) || 1);
      var d = currentTier ? parseFloat(currentTier.getAttribute('data-discount')) || 0 : 0;
      return { q: q, d: d };
    }

    function recalc() {
      if (!currentVariant) return;
      var price = currentVariant.price;
      var compare = currentVariant.compare_at_price && currentVariant.compare_at_price > price ? currentVariant.compare_at_price : price;

      // each bundle row
      root.querySelectorAll('[data-roam-bundle]').forEach(function (row) {
        var q = parseInt(row.getAttribute('data-qty'), 10) || 1;
        var d = parseFloat(row.getAttribute('data-discount')) || 0;
        var now = Math.round(price * q * (1 - d / 100));
        var was = compare * q;
        var per = Math.round(now / q);
        var nowEl = row.querySelector('[data-roam-bundle-now]');
        var wasEl = row.querySelector('[data-roam-bundle-was]');
        var perEl = row.querySelector('[data-roam-perpair]');
        if (nowEl) nowEl.textContent = fmt(now);
        if (perEl) perEl.textContent = fmt(per);
        if (wasEl) { if (was > now) { wasEl.textContent = fmt(was); wasEl.style.display = ''; } else { wasEl.style.display = 'none'; } }
      });

      // ATC + sticky reflect selected tier
      var t = tierData();
      var now = Math.round(price * t.q * (1 - t.d / 100));
      var was = compare * t.q;
      qtyInput.value = t.q;

      if (currentVariant.available) {
        atc.removeAttribute('disabled');
        if (atcLabel) atcLabel.textContent = 'Add to cart →';
      } else {
        atc.setAttribute('disabled', 'disabled');
        if (atcLabel) atcLabel.textContent = 'Sold out';
      }
      if (atcPrice) {
        atcPrice.innerHTML = fmt(now) + (was > now ? '<span class="was">' + fmt(was) + '</span>' : '');
      }
      root.querySelectorAll('[data-roam-sticky-price]').forEach(function (el) { el.textContent = fmt(now); });
    }

    /* ---- gallery sync on variant change ----
       Colour first: the thumb row narrows to that colour's shots and the main
       image follows. A variant with its own featured image then wins outright,
       so long as that image survived the filter. */
    function syncMedia() {
      filterGalleryByColor();
      if (!currentVariant || !currentVariant.featured_media) return;
      var mediaId = currentVariant.featured_media.id;
      var thumb = root.querySelector('[data-roam-thumb][data-media-id="' + mediaId + '"]');
      if (thumb && !thumb.hidden) selectThumb(thumb);
      root.querySelectorAll('[data-roam-sticky-img]').forEach(function (img) {
        if (currentVariant.featured_media.preview_image) {
          img.src = currentVariant.featured_media.preview_image.src + '&width=120';
        }
      });
    }

    function syncOptionLabels() {
      root.querySelectorAll('[data-roam-option-index]').forEach(function (field) {
        var i = parseInt(field.getAttribute('data-roam-option-index'), 10);
        var lbl = field.querySelector('[data-roam-option-value]');
        if (!lbl || selectedOptions[i] == null) return;
        // Where a variant carries a display name the picked control holds it on
        // data-display, and that name reads out in place of the option value.
        var picked = field.querySelector('[data-roam-opt][aria-checked="true"]');
        var display = picked && picked.getAttribute('data-display');
        lbl.textContent = display || selectedOptions[i];
      });
    }

    /* ---- per-option availability ----
       A value is sellable when at least one in-stock variant carries it
       alongside everything else currently picked, so picking a colour restates
       which sizes are left in that colour. Sold-out values stay clickable: the
       shopper can see the size exists and the ATC says why it cannot be bought,
       which beats a pill that silently refuses to respond. */
    function valueAvailable(pos, value) {
      return variants.some(function (v) {
        if (v.options[pos] !== value || !v.available) return false;
        return selectedOptions.every(function (val, i) {
          return i === pos || val == null || v.options[i] === val;
        });
      });
    }

    function syncAvailability() {
      // no variant data means no grounds to call anything sold out
      if (!variants.length) return;
      // Same guard as the Liquid: the signal is which values are left relative
      // to the others, so with nothing in stock at all it would strike every
      // pill through and read as a broken picker rather than a sold-out one.
      var anyStock = variants.some(function (v) { return v.available; });
      root.querySelectorAll('[data-roam-opt]').forEach(function (btn) {
        var pos = parseInt(btn.getAttribute('data-roam-opt'), 10) - 1;
        var ok = !anyStock || valueAvailable(pos, btn.getAttribute('data-value'));
        btn.setAttribute('data-available', ok ? 'true' : 'false');
        btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
      });
    }

    /* ---- ?variant= in the address bar ----
       replaceState, not pushState: a shopper trying four sizes should not have
       to press back four times to leave the page. Product pages only — see the
       data-roam-url-sync flag in the section. */
    function syncUrl() {
      if (!urlSync || !currentVariant || !window.history || !history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', currentVariant.id);
        history.replaceState({}, '', url.toString());
      } catch (e) { /* older browser: the form still carries the right id */ }
    }

    function onVariantChange() {
      currentVariant = findVariant() || currentVariant;
      if (currentVariant && idInput) idInput.value = currentVariant.id;
      syncOptionLabels();
      syncAvailability();
      syncMedia();
      syncUrl();
      recalc();
    }

    /* ---- option pickers ---- */
    root.querySelectorAll('[data-roam-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(btn.getAttribute('data-roam-opt'), 10) - 1;
        selectedOptions[pos] = btn.getAttribute('data-value');
        // toggle aria within the same group
        btn.parentElement.querySelectorAll('[data-roam-opt]').forEach(function (s) { s.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');
        onVariantChange();
      });
    });

    /* ---- bundle tiers ---- */
    root.querySelectorAll('[data-roam-bundle]').forEach(function (row) {
      row.addEventListener('click', function () {
        root.querySelectorAll('[data-roam-bundle]').forEach(function (r) { r.setAttribute('aria-checked', 'false'); });
        row.setAttribute('aria-checked', 'true');
        currentTier = row;
        recalc();
      });
    });
    // bundle promo card jumps to a tier
    root.querySelectorAll('[data-roam-set-bundle]').forEach(function (card) {
      card.addEventListener('click', function () {
        var q = card.getAttribute('data-roam-set-bundle');
        var target = root.querySelector('[data-roam-bundle][data-qty="' + q + '"]');
        if (target) target.click();
      });
    });

    /* ---- gallery ---- */
    var gallery = root.querySelector('[data-roam-gallery]');
    var mainImg = root.querySelector('[data-roam-gallery-img]');
    var counter = root.querySelector('[data-roam-counter]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-roam-thumb]'));
    var colorPos = gallery ? parseInt(gallery.getAttribute('data-roam-color-pos'), 10) || 0 : 0;
    var currentThumb = thumbs[0] || null;

    function pad(n) { return ('0' + n).slice(-2); }

    // the thumbs still on show for the selected colour
    function shownThumbs() {
      var shown = thumbs.filter(function (t) { return !t.hidden; });
      return shown.length ? shown : thumbs;
    }

    function updateCounter() {
      if (!counter) return;
      var shown = shownThumbs();
      var i = shown.indexOf(currentThumb);
      counter.textContent = pad(i + 1) + ' / ' + pad(shown.length);
    }

    function selectThumb(thumb) {
      if (!thumb) return;
      currentThumb = thumb;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
      if (mainImg) {
        mainImg.src = thumb.getAttribute('data-full');
        var timg = thumb.querySelector('img');
        if (timg) mainImg.alt = timg.alt;
      }
      updateCounter();
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { selectThumb(t); }); });

    // Liquid handleize, near enough: the option value has to reduce to the same
    // slug the thumbs were tagged with.
    function handleize(v) {
      return String(v).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }

    /* Narrow the gallery to the selected colour. A thumb with no data-colors is
       shared and always stays on show; if a colour turns out to have no shots of
       its own we leave the whole set alone rather than stranding the shopper on
       the generic ones. */
    function filterGalleryByColor() {
      if (!colorPos || !thumbs.length) return;
      var value = selectedOptions[colorPos - 1];
      if (value == null) return;
      var want = handleize(value);
      var owned = 0;
      thumbs.forEach(function (t) {
        var tags = (t.getAttribute('data-colors') || '').split(',').filter(Boolean);
        var show = tags.length === 0 || tags.indexOf(want) !== -1;
        if (show && tags.length) owned++;
        t.hidden = !show;
      });
      if (!owned) thumbs.forEach(function (t) { t.hidden = false; });
      // the main image has to land on something that is still on show
      var shown = shownThumbs();
      if (shown.indexOf(currentThumb) === -1) selectThumb(shown[0]);
      else updateCounter();
    }

    function stepGallery(dir) {
      var shown = shownThumbs();
      if (!shown.length) return;
      var i = shown.indexOf(currentThumb);
      if (i < 0) i = 0;
      selectThumb(shown[(i + dir + shown.length) % shown.length]);
    }

    var prev = root.querySelector('[data-roam-prev]');
    var next = root.querySelector('[data-roam-next]');
    if (prev) prev.addEventListener('click', function () { stepGallery(-1); });
    if (next) next.addEventListener('click', function () { stepGallery(1); });

    // hover zoom — pointer devices only. On touch, mouseenter fires on tap but
    // mouseleave often never does, so the image stayed stuck at scale(2).
    var canHover = !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var mainBox = root.querySelector('[data-roam-gallery-main]');
    if (mainBox && mainImg && canHover) {
      mainBox.addEventListener('mouseenter', function () { mainBox.classList.add('is-zoom'); });
      mainBox.addEventListener('mouseleave', function () { mainBox.classList.remove('is-zoom'); mainImg.style.transformOrigin = 'center'; });
      mainBox.addEventListener('mousemove', function (e) {
        if (!mainBox.classList.contains('is-zoom')) return;
        var r = mainBox.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        mainImg.style.transformOrigin = x + '% ' + y + '%';
      });
    }

    /* ---- sticky desktop bar visibility ---- */
    var stickyBar = root.querySelector('[data-roam-sticky]');
    var buybox = root.querySelector('.roam-pdp-main');
    if (stickyBar && buybox) {
      var onScroll = function () {
        var r = buybox.getBoundingClientRect();
        stickyBar.setAttribute('data-visible', r.bottom < 80 ? 'true' : 'false');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---- mobile bottom bar ----
       Pinned to the bottom of the viewport only once the in-page ATC has
       scrolled off the top. While the real button is still in view — or is
       simply below the fold on the way down — the bar stays hidden, so the
       shopper is never looking at two add-to-cart buttons at once and does not
       get one thrown at them before they have reached the buy box. */
    var mobileBar = root.querySelector('[data-roam-mobile-atc]');
    if (mobileBar && atc) {
      var syncMobileBar = function () {
        var r = atc.getBoundingClientRect();
        // scrolled past the top of the viewport, i.e. the whole button is above it
        var scrolledPast = r.bottom <= 0;
        mobileBar.setAttribute('data-visible', scrolledPast ? 'true' : 'false');
      };
      syncMobileBar();
      if ('IntersectionObserver' in window) {
        // The observer only tells us *when* to re-check; the rect decides
        // whether the button is on screen.
        new IntersectionObserver(syncMobileBar, { threshold: [0, 1] }).observe(atc);
      }
      window.addEventListener('scroll', syncMobileBar, { passive: true });
      window.addEventListener('resize', syncMobileBar, { passive: true });
      // the buy box grows and shrinks as variants/quantity change, which moves
      // the button without any scrolling
      if ('ResizeObserver' in window) new ResizeObserver(syncMobileBar).observe(root);
    }

    /* ---- size guide modal ---- */
    var sizeGuide = root.querySelector('[data-roam-size-guide]');
    if (sizeGuide) {
      var lastFocused = null;
      var closeSizeGuide = function () {
        sizeGuide.setAttribute('hidden', 'hidden');
        document.documentElement.style.overflow = '';
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      };
      var openSizeGuide = function (trigger) {
        lastFocused = trigger || null;
        sizeGuide.removeAttribute('hidden');
        document.documentElement.style.overflow = 'hidden';
        var closeBtn = sizeGuide.querySelector('.roam-modal__close');
        if (closeBtn) closeBtn.focus();
      };

      root.querySelectorAll('[data-roam-size-guide-open]').forEach(function (btn) {
        btn.addEventListener('click', function () { openSizeGuide(btn); });
      });
      sizeGuide.querySelectorAll('[data-roam-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeSizeGuide);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !sizeGuide.hasAttribute('hidden')) closeSizeGuide();
      });
    }

    /* ---- anchor fallback when no size-guide block is present ---- */
    root.querySelectorAll('[data-roam-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('data-roam-open'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* ---- floating bar CTAs → back to the buy box ----
       Neither the desktop nor the mobile bar adds to cart: by the time either is
       showing, the shopper has scrolled past the options, so we send them back up
       to pick a size rather than silently buying whatever happened to be selected. */
    root.querySelectorAll('[data-roam-scroll-to-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        (buybox || atc).scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* ---- AJAX add to cart ---- */
    var adding = false;
    function submitCart() {
      if (adding) return;           // one request per click, even if re-entered
      adding = true;
      var fd = new FormData(form);
      var origLabel = atcLabel ? atcLabel.textContent : '';
      if (atcLabel) atcLabel.textContent = 'Adding…';
      atc.setAttribute('disabled', 'disabled');
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          adding = false;
          atc.removeAttribute('disabled');
          if (atcLabel) atcLabel.textContent = origLabel || 'Add to cart →';
          if (!res.ok) { toast(res.data.description || 'Could not add to cart'); return; }
          afterAdd();
        })
        .catch(function () {
          adding = false;
          atc.removeAttribute('disabled');
          if (atcLabel) atcLabel.textContent = origLabel || 'Add to cart →';
          toast('Network error — please try again');
        });
    }

    function afterAdd() {
      if (cartAction === 'redirect') { window.location = shopRoot() + 'cart'; return; }

      var wantsDrawer = cartAction === 'drawer';
      Promise.all([
        fetch(shopRoot() + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); }),
        wantsDrawer ? renderCartDrawer() : Promise.resolve(false)
      ])
        .then(function (results) {
          var cart = results[0];
          var rendered = results[1];
          updateCartCount(cart);
          document.dispatchEvent(new CustomEvent('roam:added', { detail: cart, bubbles: true }));

          if (!wantsDrawer) { toast('Added to cart ✓'); return; }
          if (rendered && openCartDrawer()) return;

          // no ROAM drawer on the page — hand off to a theme-native one
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var themeDrawer = document.querySelector('cart-drawer');
          if (themeDrawer && typeof themeDrawer.open === 'function') themeDrawer.open();
          else if (themeDrawer && themeDrawer.classList) themeDrawer.classList.add('active', 'is-open');
          else toast('Added to cart ✓');
        })
        .catch(function () { toast('Added to cart ✓'); });
    }

    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); submitCart(); });
    }

    /* ---- toast ---- */
    function toast(msg) {
      var t = document.createElement('div');
      t.textContent = msg;
      t.setAttribute('style', 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:9999;background:#0c1116;color:#fff;font:600 13px/1.2 system-ui,sans-serif;padding:14px 20px;border-radius:6px;box-shadow:0 8px 30px rgba(0,0,0,.25)');
      document.body.appendChild(t);
      setTimeout(function () { t.style.transition = 'opacity .3s'; t.style.opacity = '0'; setTimeout(function () { t.remove(); }, 300); }, 2200);
    }

    // initial paint. No syncUrl here — landing on a page should not rewrite its
    // own address before the shopper has touched anything.
    recalc();
    syncOptionLabels();
    syncAvailability();
    syncMedia();
  }

  /* ---- accordions (used by accordions + FAQ sections) ------------------- */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('[data-roam-acc]').forEach(function (group) {
      if (group.dataset.roamAccBound) return;
      group.dataset.roamAccBound = '1';
      var single = group.getAttribute('data-roam-acc') !== 'multi';
      group.querySelectorAll('.roam-acc-item').forEach(function (item) {
        var head = item.querySelector('.roam-acc-head');
        if (!head) return;
        head.addEventListener('click', function () {
          var open = item.getAttribute('aria-expanded') === 'true';
          if (single) group.querySelectorAll('.roam-acc-item').forEach(function (i) { i.setAttribute('aria-expanded', 'false'); });
          item.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-roam-pdp]').forEach(initSection);
    initAccordions(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-init when sections are edited in the theme customizer
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-roam-pdp]').forEach(initSection);
    initAccordions(e.target);
  });
})();
